<!-- 
    说明：商品的详细信息，标题、价格（快币和人民币两种方式，由后端来下发）等。
    状态说明：需要区分的状态是生产or消费者（已购买未购买），不同状态展示相应的信息
    课程说明：这里主要区分是录播课还是直播课，录播课需要展示时长、集数、更新时间。直播课展示直播时间
    赚佣金说明：此模块可能会出现赚佣金入口（当从非帮卖广场进入而且用户满足帮卖的资格时候展示），否则入口是在底部吸附模块展示
    创建者：congpeizhi
    创建时间：2022/06/28
-->
<template>
    <div
        class="detail-info"
        :class="{
            'detail-info-bottom': courseTradeInfo.secKillInfoDTO !== undefined,
        }"
    >
        <!-- 消费者未购买的时候展示价格，已购买和主人态不用展示价格，包括秒杀和非秒杀两种卖课方式 -->
        <!-- 限时秒杀，秒杀有倒计时样式，当已购买或是主人态的时候不展示 -->
        <div
            v-if="
                !dataUserRole.hasAllCourseRight &&
                    courseTradeInfo.secKillInfoDTO !== undefined &&
                    dataUserRole.role !== 'TEACHER'
            "
            class="detail-info-kill"
        >
            <template v-if="!useKscoinPay">
                <span
                    class="detail-info-kill_rmb"
                    :class="{
                        'detail-info-kill_rmbAndroid': isAndroid,
                    }"
                    >￥</span
                >
                <span
                    class="detail-info-kill_price"
                    :class="{
                        'detail-info-kill_priceAndroid': isAndroid,
                    }"
                    >{{ actualPrice }}</span
                >
                <span class="detail-info-kill_original">{{`￥${payPrice}`}}</span>
            </template>
            <template v-else>
                <span
                    class="detail-info-kill_ks"
                    :class="{
                        'detail-info-kill_ksAndroid': isAndroid,
                    }"
                    >{{ actualPrice }}</span
                >
                <span class="detail-info-kill_kscoin">快币</span>
                <span class="detail-info-kill_original">{{ payPrice }}</span>
            </template>
            <KillTime
                class="detail-info-kill_time"
                :endTime="courseTradeInfo.secKillInfoDTO.secKillEndTime"
            ></KillTime>
        </div>
        <!-- 非秒杀，当已购买或是主人态的时候不展示 -->
        <div
            v-if="
                (!dataUserRole.hasAllCourseRight ||
                    dataCourse.forceShowPrice) &&
                courseTradeInfo.secKillInfoDTO == undefined &&
                dataUserRole.role !== 'TEACHER' &&
                !isFreeCourse
            "
            class="detail-info-msg"
        >
            <div class="detail-info-msg_layout">
                <p class="detail-info-msg_layout_writer">{{ priceWriter }}</p>
                <!-- 当是人民币支付的时候，展示￥、价格、原价 -->
                <template v-if="!useKscoinPay">
                    <p
                        class="detail-info-msg_layout_rmb"
                        :class="{
                            'detail-info-msg_layout_rmbAndroid': isAndroid,
                        }"
                    >
                        ￥
                    </p>
                    <p
                        class="detail-info-msg_layout_price"
                        :class="{
                            'detail-info-msg_layout_priceAndroid': isAndroid,
                        }"
                    >
                        {{ actualPrice }}
                    </p>
                    <!-- <p
                        v-if="actualPrice !== payPrice"
                        class="detail-info-msg_layout_original_unit"
                        >¥</p
                    > -->
                    <p v-if="actualPrice !== payPrice" class="detail-info-msg_layout_original">
                        {{ `￥${payPrice}` }}
                    </p>
                </template>
                <!-- 当是快币支付的时候，展示价格、快币、原价 -->
                <template v-else>
                    <p
                        class="detail-info-msg_layout_price"
                        :class="{
                            'detail-info-msg_layout_priceAndroid': isAndroid,
                        }"
                    >
                        {{ actualPrice }}
                    </p>
                    <p class="detail-info-msg_layout_coin">快币</p>
                    <p v-if="actualPrice !== payPrice" class="detail-info-msg_layout_original">
                        {{ payPrice }}
                    </p>
                </template>
                <!-- 销量 -->
                <p class="detail-info-msg_layout_sales" v-if="subscriberCount > 0">
                    已售{{ wPlus(subscriberCount) }}
                </p>
            </div>
        </div>
        <div
            :class="{
                'detail-info-fix': courseTradeInfo.secKillInfoDTO !== undefined,
                'detail-info-border': isSevenScreen,
            }"
        >
            <!-- 优惠券,我未领取的优惠券 -->
            <div class="detail-info-coupon" v-if="myVoucherList.length > 0">
                <div
                    class="detail-info-coupon_platform"
                    v-for="(item, index) in myVoucherList"
                    :key="index"
                >
                    <span class="detail-info-coupon_platform_tit" v-if="item.showBearerTypeFlag">{{
                        item.bearerType === 1 ? '平台券' : '券'
                    }}</span>
                    <span>{{ item.voucherWriter }}</span>
                </div>
                <div
                    v-if="myVoucherStatus == 1"
                    class="detail-info-coupon_get"
                    @click="clickGetCoupon"
                >
                    <span class="detail-info-coupon_get_writer">领券</span>
                    <img src="../img/arrow1.png" />
                </div>
                <div v-if="myVoucherStatus == 2" class="detail-info-coupon_get" @click="buyCourse">
                    <span class="detail-info-coupon_get_writer">用券购买</span>
                    <img src="../img/arrow1.png" />
                </div>
            </div>
            <!-- 商品的名字 -->
            <div class="detail-info-name">
                <span class="detail-info-tag" v-if="studentTag">放心学</span>
                {{ course.name }}
            </div>
            <!-- 课程相关信息，集数、更新时间、更新集数、直播时间等 -->
            <div class="detail-info-status" v-if="course.courseType !== 'OFF_SITE_COURSE'">
                <!-- 直播课 -->
                <template v-if="course.courseType === 'LIVE_ONLY'">
                    <div class="detail-info-status_unit">
                        <!-- 直播时间：xxxxx - yyyy  || x场直播·直播时间：xxxxx - yyyy -->
                        <span>{{ liveTimeWriter }}</span>
                        <span
                            v-if="
                                (courseTradeInfo.secKillInfoDTO !== undefined ||
                                    dataUserRole.hasAllCourseRight ||
                                    dataUserRole.role == 'TEACHER') &&
                                    subscriberCount > 0
                            "
                            class="detail-info-status_unit_sales"
                            >已售{{ wPlus(subscriberCount) }}</span
                        >
                    </div>
                    <div v-if="liveTimeSecondWriter" class="detail-info-status_unit">
                        <!-- 满x人截止 -->
                        <span>{{ liveTimeSecondWriter }}</span>
                    </div>
                </template>
                <!-- 录播课、 -->
                <template v-else>
                    <div class="detail-info-status_unit">
                        <!-- 共xx集 || 时长：xx分钟 || 时长：xx分钟（可是看6分钟）|| 已完更 · 共xx集 || 已更新至xx集，预计更新yy集 -->
                        <!-- 共xx集，不是连载课的情况 -->
                        <template v-if="course.lessonCount > 1 && !course.serial">
                            <span>共{{ course.lessonCount }}集</span>
                        </template>
                        <!-- 只有一集的情况下 -->
                        <template v-if="course.lessonCount == 1 && !course.serial">
                            <!-- 只有一集的&&可以试看 -->
                            <span v-if="firstLesson.trialTime > 0">
                                <template
                                    >时长{{
                                        Math.floor(firstLesson.realTime / 1000 / 60)
                                    }}分钟</template
                                >
                                <template v-if="dataUserRole.role === 'VISITOR'"
                                    >（可试看{{
                                        Math.floor(firstLesson.trialTime / 1000 / 60)
                                    }}分钟）
                                </template>
                            </span>
                            <!-- 只有一集的&&不可以试看 -->
                            <span v-if="firstLesson.trialTime == 0 || !firstLesson.trialTime">
                                <template v-if="firstLesson.realTime > 60000">
                                    时长{{ Math.floor(firstLesson.realTime / 1000 / 60) }}分钟
                                </template>
                                <template v-else>
                                    时长1分钟内
                                </template>
                            </span>
                        </template>
                        <!-- 如果是连载更新的话 -->
                        <template v-if="course.serial">
                            <span v-if="course.complyStatus === 'COMPLETE'"
                                >已完更 · 共{{ course.lessonCount }}集</span
                            >
                            <span v-if="course.complyStatus === 'ON_GOING'"
                                >已更新{{ course.lessonCount }}集，预计更新{{
                                    course.promiseUpdateLessonNum
                                }}集</span
                            >
                        </template>
                        <!-- 销量，当已经购买后或是主人态，展示销量 -->
                        <span
                            v-if="
                                ((dataUserRole.hasAllCourseRight ||
                                    dataUserRole.role === 'TEACHER') &&
                                    subscriberCount > 0) ||
                                    courseTradeInfo.secKillInfoDTO !== undefined
                            "
                            class="detail-info-status_unit_sales"
                            >已售{{ wPlus(subscriberCount) }}</span
                        >
                    </div>
                    <div class="detail-info-status_unit" v-if="course.complyStatus === 'ON_GOING'">
                        <!-- 更新结束时间 -->
                        <span>更新结束时间：</span>
                        <span>{{ updateDeadline }}</span>
                    </div>
                </template>
            </div>
            <!-- <div
                v-if="dataTask.showActivity == 1"
                class="detail-invite-card"
                @click="goInfo"
            >
                <div class="detail-invite-card-title">
                    {{ dataTask.activityTitle || '拉新福利' }}
                </div>
                <div class="detail-invite-card-des">
                    {{ dataTask.activityDescription || '领红包' }}
                </div>
                <div class="detail-invite-card-arrow"></div>
            </div> -->
            <div
                v-if="showDistributionCard"
                class="detail-invite-card"
                @click="clickDistributionCard"
            >
                <div class="detail-invite-card-title">赚佣金</div>
                <div class="detail-invite-card-des">
                    {{ `推荐此内容最多可获得￥${Number((Number(dataCourseDistribution?.commissionMaxPrice) / 100).toFixed(2)) || 0 }收益` }}
                </div>
                <div class="detail-invite-card-arrow"></div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, PropType, ref, computed, watch } from 'vue';
import {
    CourseDetailCourse,
    VoucherList,
    CourseTradeInfo,
    UserRole,
    CourseDetailLessons,
    TaskState,
    CourseDetailTags,
    CourseDetailDistribution,
    MyDistributionStatus,
} from '../service';
import { isAndroid } from '@/utils/env';
import KillTime from './info/KillTime.vue';
import dayjs from 'dayjs';
import { wPlus } from '@/utils/filters';
import { Goto } from '@/utils/url';
import { pushLogBridge } from '@/utils/weblog-bridge';
// 单位换算成w
export default defineComponent({
    components: {
        KillTime,
    },
    emits: ['buyCourse', 'voucherPopupShow', 'applyDistribution'],
    props: {
        dataCourse: {
            type: Object as PropType<CourseDetailCourse>,
            default: () => {
                return {};
            },
        },
        // 课程基本信息
        course: {
            type: Object as PropType<CourseDetailCourse>,
            default: () => {
                return {};
            },
        },
        // 权益
        dataTags: {
            type: Array as PropType<CourseDetailTags[]>,
            default: () => {
                return [];
            },
        },
        // 用户未领取的优惠券列表
        voucherList: {
            type: Array as PropType<VoucherList[]>,
            default: () => {
                return [];
            },
        },
        // 课程交易先关的信息
        courseTradeInfo: {
            type: Object as PropType<CourseTradeInfo>,
            default: () => {
                return {};
            },
        },
        // 是否用快币支付
        useKscoinPay: {
            type: Boolean,
            default: false,
        },
        // 用户角色相关的
        dataUserRole: {
            type: Object as PropType<UserRole>,
            default: () => {
                return {};
            },
        },
        // 课节相关信息
        dataLessons: {
            type: Array as PropType<CourseDetailLessons[]>,
            default: () => {
                return [];
            },
        },
        // 拉新任务
        dataTask: {
            type: Object as PropType<TaskState>,
            default: () => {
                return {};
            },
        },
        // 是否是免费课
        isFreeCourse: {
            type: Boolean,
            default: false,
        },
        // 销量
        subscriberCount: {
            type: Number,
            default: 0,
        },
        // 是否是七分屏
        isSevenScreen: {
            type: Boolean,
            default: false,
        },
        // 页面的来源
        from: {
            type: String,
            default: '',
        },
        // 课程帮卖/分销/推荐信息
        dataCourseDistribution: {
            type: Object as PropType<CourseDetailDistribution>,
            default: () => {
                return {};
            },
        },
        // 课程帮卖/分销/推荐状态
        dataMyDistributionStatus: {
            type: Object as PropType<MyDistributionStatus>,
            default: () => {
                return {};
            },
        },
    },
    setup(props, ctx) {
        // 尝鲜价or券后价or区间价
        const priceWriter = computed(() => {
            if (props.courseTradeInfo.actualPrice == props.courseTradeInfo.maxPrice) {
                return '尝鲜价';
            } else {
                return '券后价';
            }
        });
        // 支付价格的计算
        const toRMB = num => {
            return Number((num / 100).toFixed(2));
        };
        // 返回优惠券，包含已领取的券和尚未领取的券，如果有未领取的券优先展示，并出现领券入口，没有则展示已领取的券，如果两券都没有则不展示
        const myVoucherList = computed(() => {
            const vouchArr = props.voucherList.length
                ? props.voucherList.slice(0, 2)
                : props.courseTradeInfo?.recommendedCombinationVoucherList || [];
            if (vouchArr.length > 0) {
                // 由于同类型的券（平台券||商家券）是只有第一张展示类型，后面的都不展示，所以这里记录是否是第一张
                const vouchTypeObj = {
                    1: false,
                    2: false,
                };
                for (let i = 0; i < vouchArr.length; i++) {
                    // 记录同类型的券第一张才展示对应的类型，后面的都不展示
                    if (!vouchTypeObj[vouchArr[i].bearerType]) {
                        vouchTypeObj[vouchArr[i].bearerType] = true;
                        vouchArr[i].showBearerTypeFlag = true;
                    } else {
                        vouchArr[i].showBearerTypeFlag = false;
                    }
                    // 处理每张券的文案，如 1.红包 2.满xx减yy 3.折扣券
                    if (vouchArr[i].discountType === 1) {
                        // 券额券
                        vouchArr[i].voucherWriter = '限时免费';
                    } else if (vouchArr[i].discountType === 2) {
                        // 满减券要分辨是哪一种支付方式，快币或是人民币
                        const unit = props.useKscoinPay ? '快币' : '元';
                        // 如果“满xx减yy”满减券的xx等于0，说明是不需要达到条件直接减免，展示文案是红包
                        vouchArr[i].voucherWriter =
                            vouchArr[i].minimumOrderPrice === 0
                                ? `${
                                      props.useKscoinPay
                                          ? vouchArr[i].kscoinDiscountValue
                                          : toRMB(vouchArr[i].discountValue)
                                  }${unit}红包`
                                : `满${
                                      props.useKscoinPay
                                          ? vouchArr[i].kscoinMinimumOrderPrice
                                          : toRMB(vouchArr[i].minimumOrderPrice)
                                  }减${
                                      props.useKscoinPay
                                          ? vouchArr[i].kscoinDiscountValue
                                          : toRMB(vouchArr[i].discountValue)
                                  }`;
                    } else if (vouchArr[i].discountType === 3) {
                        // 折扣券
                        vouchArr[i].voucherWriter = `${vouchArr[i].discountValue / 10}折券`;
                    }
                }
            }
            return vouchArr;
        });
        // 我都优惠券状态，如果有未领取的优惠券，则展示领券，没有未领取的，但是有已领取的展示用券购买，两种都没有则隐藏
        const myVoucherStatus = computed(() => {
            // 有未领取的券
            if (props.voucherList.length > 0) {
                return 1;
            }
            // 有已领取的券
            if (props.courseTradeInfo?.recommendedCombinationVoucherList.length > 0) {
                return 2;
            }
            // 啥都没有
            return 0;
        });
        // 取出经过减免的后最终支付价格，展示在尝鲜价后面
        const payPrice = computed(() => {
            // 如果是快币支付换算成快币的价格，如果是人民币则换算成分，1rmb = 10快币
            if (props.courseTradeInfo.unitPrice) {
                return props.useKscoinPay
                    ? props.courseTradeInfo.unitPrice / 10
                    : props.courseTradeInfo.unitPrice / 100;
            }
            return '';
        });
        // 商品原价
        const actualPrice = computed(() => {
            if (props.courseTradeInfo?.actualPrice) {
                return props.useKscoinPay
                    ? props.courseTradeInfo.actualPrice / 10
                    : props.courseTradeInfo.actualPrice / 100;
            }
            return '';
        });
        // 处理直播课的文案，展示直播的时间
        const liveTimeWriter = computed(() => {
            if (props.course.courseType === 'LIVE_ONLY') {
                const startTime = dayjs(props.course.startTime || 0).format('YYYY/MM/DD');
                const endTime = dayjs(props.course.endTime || 0).format('YYYY/MM/DD');
                let timeStr = '';
                if (startTime === endTime) {
                    // 一天内展示同一个
                    timeStr = startTime;
                } else {
                    timeStr = `${startTime}-${endTime}`;
                }
                if (props.course.lessonCount === 1) {
                    return `直播时间：${timeStr} ${dayjs(props.course.startTime || 0).format(
                        'HH:mm',
                    )}-${dayjs(props.course.endTime || 0).format('HH:mm')}`;
                }
                return `${props.course.lessonCount}场直播\xa0\xa0时间：${timeStr}`;
            }
        });
        // 处理直播课的文案，展示满x人截止，剩余多少名额
        const liveTimeSecondWriter = computed(() => {
            let info = '';
            const nowTime = new Date().getTime();
            // 课程的总名额
            const number = props.courseTradeInfo.number;
            // 已经售卖的的名额
            const subscriberCount = props.subscriberCount;
            if (
                props.course.lessonCount &&
                nowTime >= props.dataLessons[props.course.lessonCount - 1]?.scheduledEndTime
            ) {
                return info;
            } else if (number > 0 && subscriberCount >= number) {
                info = `满${number}人截止，无剩余名额`;
            } else if (number > 0) {
                // 如果等于0，说明此课程未设置人数上限
                info = `满${number}人截止`;
                if (subscriberCount > 0) {
                    info += `，剩余${number - subscriberCount}名额`;
                }
            }
            return info;
        });
        /**
         * 连载更新结束时间
         */
        const updateDeadline = computed(() => {
            return dayjs(props.course.updateDeadline).format('YYYY.MM.DD');
        });
        /**
         * 跳到拉新活动页
         */
        const goInfo = () => {
            pushLogBridge('sendImmediately', 'CLICK', 'NEW_WELFARE_AREA', {
                text: '拉新福利',
            });
            Goto(props.dataTask.activityUrl);
        };
        /**
         * 领取优惠券
         */
        const clickGetCoupon = () => {
            ctx.emit('voucherPopupShow');
        };
        /**
         * 用券购买 触发买课
         */
        const buyCourse = () => {
            ctx.emit('buyCourse', null);
        };
        /**
         * 获取是否有放心学标签
         */
        const studentTag = computed(() => {
            for (let i = 0; i < props.dataTags.length; i++) {
                if (props.dataTags[i].tag == '放心学') {
                    return true;
                }
            }
            return false;
        });
        /**
         * 获取第一节课
         */
        const firstLesson = computed(() => {
            if (props.dataLessons.length) {
                return props.dataLessons[0];
            }
            return {};
        });
        /**
         * 用于判断课程信息是否展示分销卡片
         */
        const showDistributionCard = computed(() => {
            return (
                props.dataUserRole.role !== 'TEACHER' && 
                ((props.dataUserRole.isNormalTeacher || props.dataUserRole.canBeTeacher) && props.dataUserRole.canBeDistributor)&&
                props.dataCourseDistribution.canDistribute &&
                props.from !== 'distributionSquare' &&
                props.dataMyDistributionStatus.canApply
            );
        });
        // 点击卡片触发帮卖
        const clickDistributionCard = () => {
            pushLogBridge('sendImmediately', 'CLICK', 'MID_GOLDEN_BTN', {});
            ctx.emit('applyDistribution');
        };
        watch(
            () => props.dataTask?.showActivity,
            () => {
                pushLogBridge('sendImmediately', 'SHOW', 'NEW_WELFARE_AREA', {
                    text: '拉新福利',
                });
            },
        );
        watch(showDistributionCard, (val) => {
            if (val) {
                pushLogBridge('sendImmediately', 'SHOW', 'MID_GOLDEN_BTN', {});
            }
        });
        return {
            priceWriter,
            myVoucherList,
            payPrice,
            actualPrice,
            liveTimeWriter,
            liveTimeSecondWriter,
            myVoucherStatus,
            wPlus,
            goInfo,
            buyCourse,
            clickGetCoupon,
            updateDeadline,
            isAndroid,
            studentTag,
            firstLesson,
            showDistributionCard,
            clickDistributionCard,
        };
    },
});
</script>

<style lang="less" scoped>
.detail-info {
    background-color: #fff;
    margin: 12px 10px 0;
    padding-bottom: 15px;
    border-radius: 8px;
    .detail-info-kill {
        width: 100%;
        height: 68px;
        background: url(../img/kill.png);
        background-size: 100%;
        overflow: hidden;
        padding-bottom: 24px;
        box-sizing: border-box;
        display: flex;
        align-items: flex-end;
        font-family: 'PingFang SC';
        position: relative;
        &_time {
            position: absolute;
            top: 27px;
            right: 22px;
        }
        &_rmb {
            margin-left: 16px;
            color: #fff;
            line-height: 11px;
            font-weight: bold;
            font-size: 16px;
        }
        &_rmbAndroid {
            line-height: 12px;
        }
        &_price {
            font-size: 30px;
            font-weight: bold;
            color: #fff;
            line-height: 21px;
        }
        &_priceAndroid {
            line-height: 24px;
        }
        &_rmbs {
            margin-left: 4px;
            line-height: 12px;
            font-weight: bold;
            color: rgba(255, 255, 255, 0.7);
            font-size: 15px;
            text-decoration: line-through;
        }
        &_original {
            font-weight: bold;
            color: rgba(255, 255, 255, 0.7);
            text-decoration: line-through;
            font-size: 15px;
            margin-left: 4px;
            line-height: 11px;
        }
        &_original_rmbs {
            line-height: 12px;
        }
        &_ks {
            font-size: 30px;
            font-weight: bold;
            color: #fff;
            line-height: 22px;
            margin-left: 15px;
        }
        &_ksAndroid {
            line-height: 24px;
        }
        &_kscoin {
            margin-left: 2px;
            color: #fff;
            font-weight: bold;
            font-family: 'PingFang TC';
            font-size: 16px;
            line-height: 14px;
        }
    }
    .detail-info-msg {
        &_layout {
            height: 39px;
            padding: 0 12px;
            display: flex;
            flex-flow: row nowrap;
            align-items: flex-end;
            &_writer {
                font-family: 'PingFang TC';
                font-weight: bold;
                font-size: 13px;
                color: #fe3666;
                margin-right: 2px;
                line-height: 12px;
                display: flex;
                align-items: flex-end;
            }
            &_rmb {
                font-family: 'PingFang SC';
                font-weight: bold;
                font-size: 16px;
                color: #fe3666;
                line-height: 12px;
                display: flex;
                align-items: flex-end;
            }
            &_rmbAndroid {
                line-height: 13px;
            }
            &_coin {
                font-family: 'PingFang TC';
                font-weight: bold;
                font-size: 13px;
                line-height: 12px;
                color: #fe3666;
                margin-left: 2px;
                display: flex;
                align-items: flex-end;
            }
            &_price {
                font-family: 'PingFang SC';
                font-weight: bold;
                font-size: 30px;
                color: #fe3666;
                line-height: 21px;
                display: flex;
                align-items: flex-end;
            }
            &_priceAndroid {
                line-height: 24px;
            }
            &_original {
                font-family: 'PingFang SC';
                font-weight: 400;
                font-size: 15px;
                line-height: 11px;
                text-decoration-line: line-through;
                color: #9c9c9c;
                margin-left: 4px;
            }
            &_original_unit {
                font-family: 'PingFang SC';
                font-weight: 400;
                font-size: 15px;
                line-height: 12px;
                color: #9c9c9c;
                margin-left: 4px;
                padding-right: 1px;
                text-decoration-line: line-through;
            }
            &_sales {
                font-family: 'PingFang SC';
                font-size: 13px;
                line-height: 12px;
                color: #9c9c9c;
                flex-grow: 1;
                text-align: right;
            }
        }
    }
    .detail-info-name {
        padding: 0 12px;
        font-family: 'PingFang SC';
        font-weight: bold;
        font-size: 16px;
        line-height: 22px;
        color: #323233;
        padding-top: 13px;
        display: -webkit-box;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }
    .detail-info-tag {
        width: 36px;
        height: 17px;
        display: inline-block;
        font-family: 'PingFang SC';
        font-style: normal;
        font-weight: 500;
        font-size: 10px;
        line-height: 17px;
        text-align: center;
        color: #fff;
        background: #5181fb;
        border-radius: 3px;
        margin-right: 4px;
        position: relative;
        top: -2px;
    }
    .detail-info-coupon {
        padding: 13px 12px 0;
        display: flex;
        flex-flow: row nowrap;
        font-family: 'PingFang SC';
        font-weight: 400;
        font-size: 13px;
        color: #fe3666;
        position: relative;
        &_platform {
            padding: 0 3px;
            height: 18px;
            // line-height: 18px;
            display: inline-block;
            border: 0.5px solid rgb(254, 54, 102, 0.3);
            border-radius: 3px;
            margin-right: 5px;
            display: flex;
            align-items: center;
            &_tit {
                margin-right: 9px;
                position: relative;
                &::after {
                    content: '';
                    width: 2px;
                    height: 10px;
                    display: inline-block;
                    border-left: 0.5px solid rgb(254, 54, 102, 0.3);
                    position: absolute;
                    transform: translate(4px, -5px);
                    top: 50%;
                }
            }
        }
        &_get {
            text-align: right;
            display: flex;
            align-items: center;
            justify-content: end;
            position: absolute;
            right: 10px;
            margin-top: 4px;
            &_writer {
                color: #9c9c9c;
            }
            img {
                width: 12px;
                margin-top: -1px;
            }
        }
    }
    .detail-info-status {
        padding: 0 12px;
        &_unit:first-child {
            margin-top: 11px;
        }
        &_unit {
            font-family: 'PingFang SC';
            font-weight: 400;
            font-size: 14px;
            line-height: 18px;
            color: #9c9c9c;
            margin-top: 15px;
            display: flex;
            flex-flow: row nowrap;
            &_sales {
                font-size: 13px;
                flex-grow: 1;
                text-align: right;
            }
        }
    }
    .detail-info-pay {
        height: 40px;
        margin: 0 12px 1px;
        background: rgba(255, 238, 242, 0.5);
        border-radius: 4px;
        margin-top: 15px;
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        &_title {
            font-family: 'PingFang TC';
            font-weight: 600;
            font-size: 14px;
            color: #fe3666;
            margin-left: 12px;
        }
        &_writer {
            font-family: 'PingFang SC';
            font-weight: 400;
            font-size: 14px;
            color: #fe3666;
            margin-left: 6px;
        }
        img {
            width: 8px;
            margin-left: 4px;
        }
    }
    .detail-invite-card {
        height: 40px;
        margin: 13px 12px 0;
        background: rgba(255, 238, 242, 0.5);
        border-radius: 4px;
        display: flex;
        align-items: center;
        &-title {
            font-family: 'PingFang TC';
            font-style: normal;
            font-weight: bold;
            font-size: 14px;
            line-height: 14px;
            color: #fe3666;
            margin-left: 12px;
            margin-right: 6px;
        }
        &-des {
            margin-left: 6px;
            font-family: 'PingFang SC';
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            line-height: 18px;
            color: #fe3666;
        }
        &-arrow {
            margin-left: 3px;
            width: 8px;
            height: 8px;
            background-image: url('../img/invite_play.png');
            background-size: 100%;
        }
    }
}
.detail-info-fix {
    position: relative;
    top: -8px;
    background: #fff;
}
.detail-info-bottom {
    padding-bottom: 7px;
}
.detail-info-border {
    border-radius: 8px;
}
</style>
